import { getContent } from "../../Core/Content/store";
export const getAboutPillarsFn = () => getContent("about").pillars;
export const getAboutWorkflowFn = () => getContent("about").workflow;
